import cloneDeep from 'lodash/cloneDeep';

const contactInitial = {
  tiersId: null,
  nom: '',
  prenom: '',
  fonction: '',
  service: '',
  adresseContactDifferente: false,
  adresse: {
    adresse1: '',
    adresse2: '',
    adresse3: '',
    pays: '',
    ville: '',
    codePostal: '',
    intitule1: '',
    intitule2: '',
    intitule3: '',
    latitude: 0,
    longitude: 0,
  },
  telephone: '',
  portable: '',
  email: '',
  siteWeb: '',
  archive: false,
  civiliteId: null,
  typeContactId: null,
  newsletter: false,
};

export default cloneDeep(contactInitial);



// WEBPACK FOOTER //
// ./src/configuration/contactInitial.js